var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProduct1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3663 0.000691149L7.96047 1.02426L17.2348 5.27334L19.9952 4.09842L10.367 0L10.3663 0.000691149ZM6.77656 1.52879L4.85175 2.34778L13.9602 6.66667L16.0509 5.77718L6.77656 1.52809V1.52879ZM3.67959 2.84678L0.73813 4.09842L10.3663 8.19614L12.788 7.16566L3.6789 2.84678H3.67959ZM17.7047 6.10823L17.7061 9.20312C17.7061 9.41599 17.5665 9.59638 17.3744 9.65789L14.1344 11.0284C13.8925 11.13 13.6132 11.0167 13.511 10.7748C13.4854 10.7146 13.4736 10.6517 13.4736 10.5902L13.4723 7.90932L10.8446 9.02758V19.9993L20.734 16.4808V4.81858L17.7047 6.10754V6.10823ZM14.4267 7.50363V9.87214L16.751 8.88866V6.51462L14.4267 7.50363ZM0 4.81996V16.4814L9.88942 20V9.02896L0 4.81996Z",
    fill: "#152424"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProduct1);
export default __webpack_public_path__ + "static/media/product (1).7a0dab2e346955efd0baa386de454f79.svg";
export { ForwardRef as ReactComponent };